
import { mapGetters, mapActions } from 'vuex'
import productData from '@/data/products.json'

export default {
    name: "MoreInfoModal",
    props: {
        ids: {
            default: () => ['25'],
            type: Array,
        },
        form: {
            default: '120included',
            type: String,
        },
        virtual: {
            default: 'false',
            type: String,
        }
    },
    data() {
        return {
            isActive: this.active !== ''
        }
    },
    computed: {
        ...mapGetters({
            activeModal: 'pages/getActiveModal',
        }),
        products() {
            console.log('Prop IDs:', this.$props.ids);
            const ids = this.$props.ids;
            console.log('Modal IDs:', ids);
            return ids.map(id => {
                const parsedId = Number(id);
                const product = productData.find(course => course.id === parsedId);

                if (product) {
                    const newProduct = { ...product };
                    newProduct.course_attributes = this.$options.filters.courseFeatures(
                        'en',
                        newProduct.course.hours,
                        newProduct.type
                    );
                    newProduct.course_modules = this.$options.filters.courseModules(
                        this.$props.virtual !== 'false',
                        newProduct.course.hours,
                        newProduct.type
                    );
                    newProduct.priceData = this.$options.filters.priceData(newProduct);
                    newProduct.onSale = newProduct.priceData.saleType !== 'none';
                    newProduct.rand = this.rand + this.$props.form;
                    console.log('ModalProductInfo', newProduct);
                    return newProduct;
                }
                return null;
            }).filter(Boolean);
        },
        rand() {
            return Math.floor(Math.random() * 100);
        }
    },
    methods: {
        ...mapActions({
            updateActiveModal: 'pages/updateActiveModal',
        }),
        updateModal(id) {
            this.updateActiveModal(id);
            console.log('Active Modal: ', this.activeModal);
        },
        hideModal() {
            this.updateActiveModal(null);
            console.log('Active Modal: ', this.activeModal);
        }
    },
}
